<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>表单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-card class="box-card table">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>

          <div class="el-form-item">
            <label for="imgUrl" class="el-form-item__label" style="width: 100px;">
              <span style="color:#f56c6c;">*</span> 二维码：
            </label>
            <div class="el-form-item__content" style="margin-left: 100px;">
              <div id="uploadBtn_recommend" class="uploader uploader-warning"></div>
              <img
                id="imgTarget"
                style="max-height:50px;position:absolute;margin-left:30px;margin-top:-5px;border:1px solid #ddd;"
                :src="imgUrl"
              >
            </div>
          </div>
          <el-form-item label="简介" prop="summary" :rules="[{required:true,message:'请填写小程序简介'}]">
            <el-input type="textarea" v-model="ruleForm.summary"></el-input>
          </el-form-item>
          <el-form-item label="文章内容">
            <div style="position:relative;">
              <vue-ueditor-wrap v-model="content" :config="editorConfig"></vue-ueditor-wrap>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>


<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      defaultMSG: null,
      content:
        '<h2><img src="http://img.baidu.com/hi/jx2/j_0003.gif"/>Vue + UEditor + v-model双向绑定!+!$#</h2>',
      editorConfig: {
        initialFrameHeight: 500, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE()
      },
      ruleForm: {},
      domain:url.getDomain(),
      rules: {}
    };
  },
  computed: {
    imgUrl: function() {
      if (this.ruleForm["imgUrl"]) return this.domain + this.ruleForm.imgUrl;
      return "";
    }
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    var _this = this;
    /**原图上传**/
    $("#uploadBtn_recommend").uploader({
      url: url.getUpload(),
      fileExts: "jpg;png",
      text: "选择图片",
      more: false, //是否可以上传多个
      auto: true, //是否自动上传
      type: "single", //指定处理类型
      subfolder: "content", //默认后台处理简单模式 ，指定子文件夹
      onSuccess: function(data) {
        //添加到列表,每个图片上传成功都会触发
        _this.ruleForm.imgUrl = data.relativeName;
        $("#imgTarget")
          .show()
          .attr("src", _this.domain + data.relativeName);
      }
    });
  }
};
</script>